export type ClickValuePeriodInput = {
  startDate: string
  endDate: string
  value: string
}

export function getClickValuePeriodError(startDate: string, expiryDate: string, periods: ClickValuePeriodInput[]) {
  const normalized = periods.map((period) => ({ ...period, numericValue: Number(period.value) }))
  for (const period of normalized) {
    if (!period.startDate || !period.endDate) return 'Every CPC period must have a start date and an end date.'
    if (period.startDate > period.endDate) return 'A CPC period cannot end before it starts.'
    if (period.startDate < startDate || (expiryDate && period.endDate > expiryDate)) return 'CPC periods must be within the partnership dates.'
    if (period.value.trim() === '' || !Number.isFinite(period.numericValue) || period.numericValue < 0) return 'Every CPC period must have a value of zero or greater.'
  }
  const sorted = [...normalized].sort((first, second) => first.startDate.localeCompare(second.startDate) || first.endDate.localeCompare(second.endDate))
  for (let index = 1; index < sorted.length; index += 1) {
    if (sorted[index].startDate <= sorted[index - 1].endDate) return 'CPC periods cannot overlap.'
  }
  return ''
}
